import React from 'react';
import { withRouter } from 'react-router-dom';
import BaseWebService from '../../service/base_web_service';
import { ReactComponent as LogoIcon } from "../../icon/logo.svg";
import SessionBloc from '../../bloc/session_bloc';

class ConnectivityScreen extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this.setState({});
    }

    handleLanguageChange(language) {
        this.setState({});
    }

    render() {
        const successStyle = {
            color: '#6FCF97',
            fontFamily: 'OpenSans-Bold',
            fontSize: '24px',
            marginBottom: '16px',
        };

        const unsuccessStyle = {
            color: 'rgb(255, 0, 0)',
            fontWeight: 'bold',
            fontSize: '24px',
            marginBottom: '16px',
        };

        const imgMargins = {
            marginRight: 30,
            marginLeft: 10,
        };

        const tableLength = {
            tableLayout: 'fixed',
        };

        return (
            <><div className="header">
                <nav className="d-flex align-items-start" onClick={(e) => SessionBloc.backToDashboard()}>
                    <LogoIcon />
                </nav>
            </div>
                <div className="row">
                    <div
                        className="col-md-12 text-center"
                        style={{ display: 'block' }}
                    >
                        <div className="h-100 row d-flex align-items-center">
                            <div className="col-md-3"></div>
                            <div className="col-md-6 h-100">
                                <div style={{ height: "280px" }} />
                                <div className="informationcontainer">
                                    <div className="align-self-center" style={{ marginBottom: 41, marginTop: 50 }}>
                                        <div className="text-center" style={unsuccessStyle}>{`v${process.env.REACT_APP_RELEASE_VERSION} Connectivity`}</div>
                                        <div>
                                            <p dangerouslySetInnerHTML={{ __html: 'Successful connection to FWD CUEPACS Portal' }}></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3"></div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(ConnectivityScreen);
